/**
 * shortenCompanyName
 * Removes common Hebrew suffixes from institutional company names (בע"מ, גמל ופנסיה, etc.)
 */
export function shortenCompanyName(name) {
  if (!name) return "אחר";
  let s = name;
  if (s.includes("קרן הגימלאות המרכזית של עובדי ההסתדרות")) return "קג\"מ";
  
  return s
    .replace(/גמל ופנסיה בע"מ|פנסיה וגמל בע"מ|פנסיה וגמל בעמ|גמל ופנסיה בעמ/g, "")
    .replace(/חברה לניהול קופות גמל בע"מ|קרנות פנסיה וקופות גמל בע"מ/g, "")
    .replace(/פנסיה וגמל|גמל ופנסיה|קופות גמל|קרנות פנסיה|ניהול|ניצוץ/g, "")
    .replace(/בע"מ|בעמ/g, "")
    .replace(/חברה לניהול/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * normalizeId
 * Ensures that IDs (especially TAZ) are exactly 9 digits, taken from the end,
 * correctly handling padded strings like '0000000054173521'.
 */
export function normalizeId(id) {
  if (!id) return id;
  const str = String(id).trim();
  if (str === "—" || str === "") return str;
  return str.padStart(9, "0").slice(-9);
}
